import React, { useContext, useEffect } from 'react'
import "./AdministrationNavigation.css"
import { Route, BrowserRouter, Switch } from 'react-router-dom'
import { Container, TabButton } from '../Library'
import { LanguageContext } from '../Language/LanguageContext'
import { faChartPie, faLandmark, faCubes, faComment, faScroll, faPuzzlePiece, faFileAlt, faUsersCog, faUsers } from '@fortawesome/free-solid-svg-icons'
import { setDocumentTitle } from '../AppTitle'

import Buildings from './Buildings'
import CreateBuilding from './CreateBuilding'
import BuildingDetail from './BuildingDetail'
import FeedbackResponse from './FeedbackResponse'
import FeedbackDetail from './FeedbackDetail'
import Package from './Package'
import Feature from './Feature'
import CreatePackage from './CreatePackage'
import EditPackage from './EditPackage'
import AdminDashboard from './AdminDashboard'
import ActivityLog from './ActivityLog'
import TermsandPolicies from '../TermsandPolicies/TermsandPolicies'
import NotFound from '../DefaultPage/NotFound'
import SuperadminAssign from './SuperadminAssign'
import UserAlias from './UserAlias'

function AdministrationNavigation() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration

    useEffect(()=>{
        setDocumentTitle("Administration")
    },[])

    return (
        <Container topbarTitle={lang.administration}>
            <BrowserRouter basename="/administration">
                <div className="nav-container">
                    <TabButton to="/" title={lang.dashboard} icon={faChartPie} exact/>
                    <TabButton to="/buildings" title={lang.buildings} icon={faLandmark}/>
                    <TabButton to="/package" title={lang.packages} icon={faCubes}/>
                    <TabButton to="/feature" title={lang.feature} icon={faPuzzlePiece}/>
                    <TabButton to="/feedback" title={lang.feedback} icon={faComment} count={localStorage.getItem("admin_count")}/>
                    <TabButton to="/user-alias" title={lang.user_alias_management} icon={faUsers}/>
					<TabButton to="/superadmin-assign" title={lang.superadmin} icon={faUsersCog}/>
                    <TabButton to="/systemlog" title={lang.system_log} icon={faScroll}/>
                    <TabButton to="/terms" title={lang.term} icon={faFileAlt}/>
                </div>
                <hr/>
                <Switch>
                    <Route path="/" exact>
                        <AdminDashboard/>
                    </Route>
                    <Route path="/buildings" exact>
                        <Buildings/>
                    </Route>
                    <Route path="/buildings/create">
                        <CreateBuilding/>
                    </Route>
                    <Route path="/buildings/view/:id">
                        <BuildingDetail/>
                    </Route>
                    <Route path="/feedback" exact>
                        <FeedbackResponse/>
                    </Route>
                    <Route path="/feedback/:id">
                        <FeedbackDetail/>
                    </Route>
                    <Route path="/feature">
                        <Feature/>
                    </Route>
                    <Route path="/package" exact>
                        <Package/>
                    </Route>
                    <Route path="/package/create">
                        <CreatePackage/>
                    </Route>
                    <Route path="/package/edit/:id">
                        <EditPackage/>
                    </Route>
                    <Route path="/systemlog">
                        <ActivityLog/>
                    </Route>
                    <Route path="/terms">
                        <TermsandPolicies/>
                    </Route>
					<Route path="/user-alias">
						<UserAlias/>
					</Route>
                    <Route path="/superadmin-assign">
                        <SuperadminAssign/>
                    </Route>
                    <Route>
                        <NotFound/>
                    </Route>
                </Switch>
            </BrowserRouter>
        </Container>
    )
}

export default AdministrationNavigation
